<template>
	<div>
		<el-collapse>
			<el-collapse-item title="资料审核信息" name="1">
				<div class="process-item" v-if="!isPrepaid">
					<p>此单是否是资料或实物候补</p>
					<el-tag type="success" v-if="form.partsClaimWarranty.isAdditional == '1'">是</el-tag>
					<el-tag type="danger" v-else>否</el-tag>
				</div>
				<div class="process-item" v-if="!isPrepaid">
					<p>此单是否需要实物邮寄，如果需要邮寄下方地址不能为空</p>
					<el-tag type="success" v-if="form.partsClaimWarranty.isNeedMailed == '1'">需要邮寄</el-tag>
					<el-tag type="danger" v-else>无需邮寄</el-tag>
				</div>
				<div v-if="form.partsClaimWarranty.isNeedMailed == '1' && !isPrepaid" class="process-item">
					<p>填写实物收件方信息</p>
					<el-select v-model="form.partsClaimWarranty.innerAdvanceCode" disabled>
						<el-option
							v-for="item in innerAdvanceOptions"
							:key="item.advanceCode"
							:label="`${item.advanceCode}/${item.companyName}/${item.address}/${item.telephone}/${item.contact}`"
							:value="item.advanceCode"></el-option>
					</el-select>
				</div>
				<div class="process-item">
					<h2 v-if="isPrepaid">此单为先行赔付无需邮寄</h2>
					<p>保修状态(必选)</p>
					<el-tag type="success" v-if="form.partsClaimWarranty.warrantyStatus == '1'">常规保修期</el-tag>
					<el-tag type="danger" v-else>延长保修期</el-tag>
				</div>
				<div class="process-item">
					<p>审批批注</p>
					<span>{{ auditRmark1 }}</span>
				</div>
			</el-collapse-item>

			<el-collapse-item title="实物审批信息" name="2" v-if="auditRmark2">
				<div class="flex part-info-box" v-for="(part, index) in partsDetailListPass" :key="index">
					<div class="flex-1">
						<div class="part-info-item">
							<div class="info-box">
								<p class="title">机器零件名称</p>
								<p class="content">{{ part.partsName }}</p>
							</div>
							<i class="el-icon-tickets" @click="$copyText(part.partsName)"></i>
						</div>
						<div class="part-info-item">
							<div class="info-box">
								<p class="title">机器零件编号</p>
								<p class="content">{{ part.partsNumber }}</p>
							</div>
							<i class="el-icon-tickets" @click="$copyText(part.partsNumber)"></i>
						</div>
						<div class="part-info-item">
							<div class="info-box">
								<p class="title">申请数量</p>
								<p class="content">{{ part.partsAmount }}</p>
							</div>
							<i class="el-icon-tickets" @click="$copyText(part.partsAmount)"></i>
						</div>
						<div class="part-info-item" v-if="part.partsBatchNumber != null">
							<div class="info-box">
								<p class="title">批号</p>
								<p class="content">{{ part.partsBatchNumber }}</p>
							</div>
							<i class="el-icon-tickets" @click="$copyText(part.partsBatchNumber)"></i>
						</div>
						<img class="watermark" v-if="[-1, -2].includes(part.auditStatus)" src="@/assets/images/claim-fail.png" alt="" />
						<img class="watermark" v-if="part.auditStatus == 3" src="@/assets/images/claim-success.png" alt="" />
					</div>
					<div class="flex-1 part-info-box-right">
						<div class="right-item">实物检测结果： 拒绝</div>
						<div class="right-item">零件索赔进度： 实物审批被拒</div>
						<div class="right-item" v-if="part.partsResult == '1' && part.partsClaimExpress != null">
							<el-button type="info" @click="handleAddressInfo(part.id)">查看索赔退件信息</el-button>
						</div>
						<div class="right-item flex" v-if="part.fileList.length">
							<span>附件说明</span>
							<div class="flex-1">
								<FileList :file-list="part.fileList" class="mt4"></FileList>
							</div>
						</div>
					</div>
				</div>
				<div class="process-item">
					<p>
						申请方的CPI地址
						<!--<span class="tips">(之后相关邮寄都将发往该地址)</span>-->
					</p>
					<el-select v-model="form.partsClaimWarranty.applyAdvanceCode" disabled>
						<el-option
							v-for="item in applyAdvanceOptions"
							:key="item.advanceCode"
							:label="`${item.advanceCode}/${item.companyName}/${item.address}/${item.telephone}/${item.contact}`"
							:value="item.advanceCode"></el-option>
					</el-select>
				</div>
				<div class="process-item">
					<p>
						保修截至日期
						<span class="tips">(在保修张数以内)</span>
					</p>
					<el-tag type="success" v-if="form.partsClaimWarranty.warrantyExpireType == '1'">按购货发票日期保修</el-tag>
					<el-tag type="success" v-if="form.partsClaimWarranty.warrantyExpireType == '2'">按理光出库日保修</el-tag>
					<el-tag type="success" v-if="form.partsClaimWarranty.warrantyExpireType == '3'">其他</el-tag>
					<el-date-picker
						v-model="form.partsClaimWarranty.warrantyExpireDate"
						format="yyyy-MM-dd"
						value-format="yyyy-MM-dd"
						type="date"
						class="ml10"
						disabled></el-date-picker>
				</div>
				<div class="process-item" v-if="form.partsClaimWarranty.faultyExpress != null">
					<p>请根据物流情况填写索赔件实际到货时间</p>
					<el-date-picker
						v-model="form.partsClaimWarranty.receivedTime"
						type="datetime"
						format="yyyy-MM-dd HH:mm:ss"
						value-format="yyyy-MM-dd HH:mm:ss"
						disabled></el-date-picker>
				</div>
				<div class="process-item">
					<p>审批批注</p>
					<span>{{ auditRmark2 }}</span>
				</div>
				<div class="report-book-box">
					<h2>现场技术问题报告书</h2>
					<FileList :file-list="issueReportFileIdList" class="mt4"></FileList>
				</div>
			</el-collapse-item>

			<el-collapse-item title="索赔发货信息" name="3" v-if="partsDetailList.length">
				<div class="flex part-info-box" v-for="(part, index) in partsDetailList" :key="index">
					<div class="flex-1">
						<div class="part-info-item">
							<div class="info-box">
								<p class="title">机器零件名称</p>
								<p class="content">{{ part.partsName }}</p>
							</div>
							<i class="el-icon-tickets" @click="$copyText(part.partsName)"></i>
						</div>
						<div class="part-info-item">
							<div class="info-box">
								<p class="title">机器零件编号</p>
								<p class="content">{{ part.partsNumber }}</p>
							</div>
							<i class="el-icon-tickets" @click="$copyText(part.partsNumber)"></i>
						</div>
						<div class="part-info-item" v-if="part.partsNumberNew != null">
							<div class="info-box">
								<p class="title">机器零件新编号</p>
								<p class="content">{{ part.partsNumberNew }}</p>
							</div>
							<i class="el-icon-tickets" @click="$copyText(part.partsNumberNew)"></i>
						</div>
						<div class="part-info-item">
							<div class="info-box">
								<p class="title">申请数量</p>
								<p class="content">{{ part.partsAmount }}</p>
							</div>
							<i class="el-icon-tickets" @click="$copyText(part.partsAmount)"></i>
						</div>
						<div class="part-info-item" v-if="part.partsBatchNumber != null">
							<div class="info-box">
								<p class="title">批号</p>
								<p class="content">{{ part.partsBatchNumber }}</p>
							</div>
							<i class="el-icon-tickets" @click="$copyText(part.partsBatchNumber)"></i>
						</div>
						<img class="watermark" v-if="[-1, -2].includes(part.auditStatus)" src="@/assets/images/claim-fail.png" alt="" />
						<img class="watermark" v-if="part.auditStatus == 3" src="@/assets/images/claim-success.png" alt="" />
					</div>
					<div class="flex-1 part-info-box-right">
						<div class="right-item">实物检测结果： 同意</div>
						<div class="right-item">零件索赔进度： {{ part.auditStatus == -2 ? "拒绝发货" : "索赔成功" }}</div>
						<div class="right-item" v-if="part.estimatedShippingTime">预计发货时间： {{ part.estimatedShippingTime }}</div>
						<div class="right-item word-bread-all" v-if="part.auditStatus == 2">发货批注： {{ part.currentAudit.remark }}</div>
						<div class="right-item">
							{{ part.auditStatus == "-2" ? "拒绝理由" : "审批批注" }}
							<el-input type="textarea" :rows="2" v-model="part.currentAudit.remark" disabled></el-input>
						</div>
						<div class="right-item" v-if="part.auditStatus == 3">
							发货订单号
							<el-input v-model="part.shippingOrderNo" disabled></el-input>
						</div>
						<div class="right-item" v-if="part.auditStatus == 3">
							请填写索赔件实际发货时间
							<br />
							<el-date-picker
								v-model="part.actualShippingTime"
								type="datetime"
								format="yyyy-MM-dd HH:mm:ss"
								value-format="yyyy-MM-dd HH:mm:ss"
								disabled></el-date-picker>
						</div>
						<div class="right-item" v-if="part.auditStatus == 3">
							<el-button type="info" @click="handleCheckExpress(part.partsClaimExpress)">查看索赔发货信息</el-button>
						</div>
					</div>
				</div>
			</el-collapse-item>
		</el-collapse>
		<ShowAddressInfo ref="showAddressInfo"></ShowAddressInfo>
	</div>
</template>

<script>
import { processInfo } from "@/api/claim";
import FileList from "./FileList.vue";
import ShowAddressInfo from "./showAddressInfo.vue";
export default {
	name: "CommonCollapse1",
	components: {
		FileList,
		ShowAddressInfo,
	},
	data() {
		return {
			form: {
				partsClaimWarranty: {
					isAdditional: "",
					isNeedMailed: "",
					warrantyStatus: "",
					innerAdvanceCode: "",
					applyAdvanceCode: "",
					warrantyExpireType: "",
					warrantyExpireDate: "",
					receivedTime: "",
					faultyExpress: null,
				},
			},
			auditRmark1: "",
			auditRmark2: "",
			isPrepaid: false, // 是否为先行赔付
			innerAdvanceOptions: [],
			applyAdvanceOptions: [],
			issueReportFileIdList: [],
			partsDetailListPass: [],
			partsDetailList: [],
		};
	},
	mounted() {
		this.getInfo();
	},
	methods: {
		getInfo() {
			// 获取单个索赔信息
			const claimId = sessionStorage.getItem("claimId") || this.$route.query.claimId;
			processInfo(claimId, false)
				.then((res) => {
					this.form = res.data;
					this.isPrepaid = res.data.partsClaimWarranty.isPrepaid == "1";
					if (res.data.partsClaimWarranty.applyAdvanceCode) {
						this.getAdvance({
							advanceType: "0",
							advanceCode: res.data.partsClaimWarranty.applyAdvanceCode,
						});
					}
					if (res.data.partsClaimWarranty.innerAdvanceCode) {
						this.getAdvance({
							advanceType: "1",
							advanceCode: res.data.partsClaimWarranty.innerAdvanceCode,
						});
					}
					this.issueReportFileIdList = res.data.partsClaimWarranty.issueReportFileList || [];
					if (res.data.hisAudit) {
						for (const element of res.data.hisAudit) {
							if ([3, 5].includes(element.auditStatus)) {
								this.auditRmark1 = element.remark;
							}
							if ([4].includes(element.auditStatus)) {
								this.auditRmark2 = element.remark;
							}
						}
					}
					// 实物审批拒绝
					let partsDetailListPass = [];
					// 索赔发货
					let partsDetailList = [];
					for (const element of res.data.partsDetailList) {
						if (element.currentAudit && element.currentAudit.auditStatus) {
							if ([-1].includes(element.currentAudit.auditStatus)) {
								element.auditStatus = element.currentAudit.auditStatus;
								partsDetailListPass.push(element);
							}
							if ([-2, 3].includes(element.currentAudit.auditStatus)) {
								element.auditStatus = element.currentAudit.auditStatus;
								partsDetailList.push(element);
							}
						}
					}
					this.partsDetailListPass = partsDetailListPass;
					this.partsDetailList = partsDetailList;
				})
				.catch((err) => {
					this.$message.error(err);
				});
		},
		getAdvance(params) {
			let self = this;
			self.$request.post("getClaimRepairAdvance", false, params, function (r) {
				if (r.code == "0") {
					if (params.advanceType == "0") {
						self.applyAdvanceOptions = r.data.slice(0, 10);
					}
					if (params.advanceType == "1") {
						self.innerAdvanceOptions = r.data.slice(0, 10);
					}
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 点击查看实物寄件信息
		handleCheckExpress(faultyExpress) {
			this.$refs.showAddressInfo.init(faultyExpress);
		},
	},
};
</script>

<style scoped>
.el-collapse ::v-deep .el-collapse-item__header {
	font-size: 18px;
	font-weight: bold;
	padding-left: 20px;
}
.process-item {
	margin-top: 10px;
	p {
		font-size: 1rem;
		font-weight: 400;
		line-height: 1.75;
		letter-spacing: 0.00938em;
		margin-bottom: 10px;
	}
	.el-select {
		width: 100%;
	}
}
.el-collapse-item {
	margin-bottom: 15px;
	padding: 0 15px;
	box-shadow:
		0px 2px 1px -1px rgba(0, 0, 0, 0.2),
		0px 1px 1px 0px rgba(0, 0, 0, 0.14),
		0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}
.ml10 {
	margin-left: 10px;
}
.part-info-box {
	margin: 10px 5px;
	box-shadow:
		0px 2px 1px -1px rgba(0, 0, 0, 0.2),
		0px 1px 1px 0px rgba(0, 0, 0, 0.14),
		0px 1px 3px 0px rgba(0, 0, 0, 0.12);
	border-radius: 5px;
	.flex-1 {
		position: relative;
		min-width: 0;
		word-wrap: break-word;
		.watermark {
			width: 100px;
			position: absolute;
			top: 0;
			right: 0;
		}
	}
}
.part-info-item {
	display: flex;
	align-items: flex-end;
	.el-form-item {
		flex: 1;
		margin-bottom: 5px;
	}
	.info-box {
		flex: 1;
		.title {
			font-size: 16px;
			margin-top: 10px;
		}
		.content {
			border: 1px solid #ddd;
			border-radius: 5px;
			padding: 9px 12px;
			margin-top: 5px;
			font-size: 13px;
		}
	}
	i {
		font-size: 28px;
		cursor: pointer;
		margin-bottom: 10px;
	}
}
.part-info-box-right {
	background-color: rgba(0, 0, 0, 0.02);
	font-size: 16px;
	.right-item {
		margin-bottom: 10px;
	}
}
.flex {
	display: flex;
}
.flex-1 {
	flex: 1;
	padding: 10px;
	min-width: 0;
	word-wrap: break-word;
}
h3 {
	margin-left: 10px;
}
.el-collapse-item {
	position: relative;
}
.el-collapse-item ::v-deep .el-collapse-item__arrow {
	position: absolute;
	left: 10px;
	top: 22px;
}
</style>
